import Config from '@app/config';

export const MODE = Config.MODE;

export const SENTRY = Config.SENTRY;

export const CRYPTO = Config.CRYPTO;

export const REQUEST = Config.REQUEST;
